export default "{\n    \"facilityCountLabel_one\": \"{{count}} instalación\",\n    \"facilityCountLabel_other\": \"{{count}} instalaciones\"\n}\n"